export default __webpack_public_path__ + "static/pricing-modal-image-bec16d162556f5ca68d4c7139079ad15.jpg";